"use client";

import { LS_REFERRAL_CODE_KEY } from "@humanex/ui/libs";
import { useEffect } from "react";

import { useVerifyReferralCode } from "@/hooks/queries/use-referral-stats";

export const REF_CODE_SEARCH_PARAM = "ref";

export function useReferralCodeHandler(code: string | undefined) {
  const verifyReferralCode = useVerifyReferralCode({
    onSuccess: (code) => {
      localStorage.setItem(LS_REFERRAL_CODE_KEY, code);
    }
  });

  useEffect(() => {
    if (!code) return;

    verifyReferralCode.mutate(code);
  }, [code]);

  return null;
}
